import { Box, Grid, Image } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import React, { FC, memo } from "react";
import CropPickerInput from "../../../components/ImageCropPicker/CropPickerInput";

interface IServicesPage {
  form: UseFormReturnType<TPagesContent>;
}

const ServicesPage: FC<IServicesPage> = ({ form }) => {
  return (
    <Box my={20}>
      <Grid>
        <Grid.Col lg={12}>
          {form.values?.service?.heroBanner && (
            <Image
              src={
                typeof form.values?.service?.heroBanner === "string"
                  ? form.values?.service?.heroBanner
                  : URL.createObjectURL(form.values?.service?.heroBanner)
              }
              my={10}
            />
          )}
          <CropPickerInput
            name={"service.heroBanner"}
            label="Hero Banner (ratio: 113 × 40)"
            formHandler={form}
            pickerRatio={113 / 40}
          />
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default memo(ServicesPage);
